<template>
  <template v-if="toolboxGroup">
    <IconText size="24" style="padding:10px;" />
    <p>Text</p>
  </template>
  <template v-else>
    <div :data-element-id="elementId" class="draggable text show-editor">
      <ProsemirrorEditor
          class="text"
          :elementId="elementId"
          :alternateColor="elementAlternateColor"
          defaultColor="#333"
          :defaultFontName="theme.fontName"
          :editable="editable"
          :viewer="viewer"
          :value="label"
          :style="getStyle()"
          @update="value => elementData.text = value"
      />
    </div>
  </template>
</template>

<script setup lang="ts">
import {computed, onMounted, toRefs, watch, getCurrentInstance} from 'vue'
import {useGivingTreeStore} from '@/store/givingTree'
import useComputedTreeValue from "@/views/components/element/hooks/useComputedTreeValue.ts";
import ProsemirrorEditor from "@/views/components/element/ProsemirrorEditor.vue";
import {storeToRefs} from "pinia";
import {useSlidesStore, useWidgetStore} from "@/store";

const givingTreeStore = useGivingTreeStore()
const { selectedWidget } = storeToRefs(useWidgetStore())
const { theme } = storeToRefs(useSlidesStore())

const props = defineProps({
  elementData: {
    type: Object
  },
  viewer: {
    type: Boolean,
    default: false
  }
})

const { elementData } = toRefs(props)

const elementId = computed(() => elementData.value?.id ?? null)
const elementHookId = computed(() => elementData.value?.hookId ?? '')
const elementAlternateColor = computed(() => elementData.value?.alternateColor ?? null)
const elementText = computed(() => elementData.value?.text ?? '')
const label = computed(() => elementText.value !== '' ? elementText.value : getComputedLabel.value)

const editable = computed(() => {
  return selectedWidget.value?.id === elementId.value
})

const toolboxGroup = computed(() => {
  const parentClassList = getCurrentInstance().parent.attrs.class;
  return parentClassList === "dragArea toolbox-group"
});

const px = (input, defaultValue) => {
  if (input) {
    return `${input}px`
  }
  else {
    return defaultValue
  }
}

const getStyle = () => {
  return {
    maxWidth: '100%',
    width: px(elementData.value.style?.width, ''),
    height: px(elementData.value.style?.height, ''),
  }
}

onMounted(() => {
  if (elementHookId.value) getActiveHookId(elementHookId.value)
})

const { getActiveHookId, getComputedLabel, setComputedValue } = useComputedTreeValue()

watch(elementHookId, (newVal) => {
  if (newVal) {
    getActiveHookId(newVal)
    const value = givingTreeStore.getWidgetValue(newVal)
    setComputedValue(value.value)
  }
}, { deep: true })

</script>

<style scoped>
.text { width: 100%; text-align: left; }
:deep(.text p) { margin: 0; }

:deep(.alternate-color span) {
  color: v-bind(elementAlternateColor) !important;
}

</style>
